import { toast } from "react-toastify";
import { apiget, apipost } from "../service/API";

/* Get Category API */
const get_category = async() => {
  try {
    const getCategoryResult = await apiget("get-categories");
    // Show Error Message
    if (getCategoryResult?.data?.status === false) {
      toast.error(getCategoryResult.data.message);
      return false;
    }

    // Return Response
    return getCategoryResult;
  } catch (error) {
    console.error(`Error while getting category: ${error}`);
  }
};

/* Get Sub Category By Category API */
const get_sub_category_by_category = async(categories) => {
  try {
    const updatedCategories = await Promise.all(
      categories?.data.map(async (category) => {
        const data = {
          category_id: JSON.stringify(category.id),
        };
        const getSubCategoriesResult = await apipost("get-sub-category", data);
        // API Error While Get Sub Category
        if ((getSubCategoriesResult?.data?.status === false) || (categories?.data?.status === false)) {
          toast.error(getSubCategoriesResult?.data?.message);
          return false;
        }
        if ((getSubCategoriesResult?.status === false) || (categories?.data?.status === false)) {
          toast.error(getSubCategoriesResult?.message);
          return false;
        }
        // Push Sub Category Data By Category
        if (getSubCategoriesResult?.data?.data && getSubCategoriesResult?.data?.status === true) {
          return {
            ...category,
            get_sub_category: getSubCategoriesResult.data.data.filter((sub_category) => sub_category.category_id === category.id),
          };
        }
        return category;
      })
    );

    // Return Response
    return updatedCategories;
  } catch (error) {
    console.error(error);
  }
};

/* Exporting all Functions for reuseing in differnt components */
const sub_category_by_category = {
    get_sub_category_by_category,
    get_category,
};
export default sub_category_by_category;